module.exports = __webpack_public_path__ + "05ae091cdcad00d84c690eb7730dfee4.svg";